import React from 'react';
import { Outlet, useLoaderData } from 'react-router-dom';

export default function GetPayment() {
  // PAYMENT
  const { data: payment } = useLoaderData();

  return <Outlet context={payment} />;
}
